import React, { useEffect, useRef, useState } from "react";
import "../../assets/css/business-partner/onboarding.css";
import AutoComplete from "../components/autocomplete-input";
import { list_branch_master } from "../../redux/prefered-master/list-branch-master";
import TextFiealdInput from "../components/textFiald";
import {
  Autocomplete,
  Button,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Checkbox from "@mui/material/Checkbox";
import { useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router";
import { raise_api_call_add_general_setting } from "../../redux/general-setting/add-general-setting-reducer";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  raise_api_call_Create_partner,
  Create_partner_is_success,
  create_partner_complete_api,
} from "../../redux/business-partner/partner-master/create-partner-master-reducer";
import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import { list_group_master } from "../../redux/sap-master/group-master";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
import { configs, COUNTRIES } from "../../common";
import { test_agreement_available_from_api } from "../../redux/business-partner/onboarding/check-agreement-valid-or-not";
import CompletePopup from "../components/response-pop-up";
import { useCommonContext } from "../../Utils/commonContext";

const OnBoarding = () => {
  const [country_code, setCountry_code] = React.useState(91);

  const [responsePopup, setResponsePopup] = useState<boolean>(false);

  const [submitData, SetSubmitData] = useState({});
  const { setTitleContext } = useCommonContext();

  const generalSettingList = useSelector((state: any) => state.GeneralSetting);
  const onboardingData = useSelector((state: any) => state.AddPartnerData);
  const group_master_data = useSelector((state: any) => state.GroupMasterList);
  const createApi = useSelector((state: any) => state.CreatePartnerDetails);
  const navigate = useNavigate();
  const [stateKey, setStateKey] = useState<string>("");
  const [payment_term_code, setpayment_term_code] = useState<any>("");
  const branch_master_data = useSelector(
    (state: any) => state.ListBranchMaster
  );
  const onboardingValues: any =
    Object.keys(onboardingData.data).length != 0 ? onboardingData.data : false;
  const regExp = /\b\d{5}\b/;
  // validations
  const validationSchema = Yup.object().shape({
    company_name: Yup.string()
      .max(100, "maximum 100 character")
      .matches(/^[a-zA-Z0-9\s]+$/, "special characters are not acceptable")
      .required("Required"),
    alter_name: Yup.string()
      .max(100, "maximum 100 character")
      .required(" Required"),
    type_of_business: Yup.string().required(" Required"),
    contact_phone: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .max(50, "maximum 50 character")
      .required(" Required"),
    about: Yup.string()
      .max(1000, "maximum 1000 character")
      .required("Required"),
    city: Yup.string()
      .max(100, "maximum 100 character")
      .required("Required")
      .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
    state: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
    currency: Yup.string().required("Required"),
    annul_turn_over: Yup.string()
      .required("Required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .max(10),
    contact_person: Yup.string()
      .max(50, "maximum 50 character")
      .required("Required"),
    contact_email_id: Yup.string()
      .email("contact_email_id is invalid")
      .required("Required"),
    branch: Yup.array(
      Yup.object({
        name: Yup.string().required("Required"),
        value: Yup.boolean().required("Required"),
      })
    ).min(1, "Required"),
    payment_terms: Yup.string()
      .required("payment terms is required")
      .nullable(),
    employee_id: Yup.number().notRequired(),
    group_name: Yup.string().required("Required"),
    partner_type: Yup.string().required("Required"),
  });
  // console.log(onboardingValues);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      company_name: "",
      alter_name: "",
      type_of_business: "",
      contact_phone: "",
      about: "",
      country_code: "+91",
      city: "",
      state: "",
      country: "",
      employee_id: "2",
      currency: "",
      annul_turn_over: "",
      contact_person: "",
      contact_email_id: "",
      payment_terms: onboardingValues
        ? onboardingValues.paymentTerms.length === 0
          ? ""
          : onboardingValues.paymentTerms[0].payments_terms
        : "",
      branch: [],
      group_name: "",
      partner_type: "",
    },

    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;

  const dispatch = useDispatch();
  const scrollRef = useRef<any>(null);
  // scrollRef.current
  //   ? scrollRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "center",
  //       inline: "nearest",
  //     })
  //   : console.log("");
  //   Dialog
  const [open, setOpen] = React.useState(false);
  const [filter_partner_type, setFilterPartnerType] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // useEffect
  useEffect(() => {
    dispatch(list_branch_master(""));
    dispatch(list_group_master(""));
    dispatch(raise_api_call_list_general_setting(""));
    if (createApi.isSuccess) {
      resetForm();
      dispatch(Create_partner_is_success(""));
    }
    if (createApi.api_completed) {
      setResponsePopup(true);
      dispatch(create_partner_complete_api(false));
    }
  }, [createApi]);

  // submit
  const submit = (e: any) => {
    const branches: any = [];
    e.branch.forEach((a: any) => {
      if (a.value) {
        branches.push(a.id);
      }
    });
    const data = {
      id: onboardingValues ? onboardingValues.id : null,
      company_name: String(e.company_name).trimEnd(),
      foreign_name: String(e.alter_name).trimEnd(),
      bussiness_type: e.type_of_business,
      partner_type: e.partner_type,
      employee_id:
        e.partner_type == "V" && e.group_name == "162"
          ? e.employee_id.length != 0
            ? e.employee_id
            : null
          : null,
      group_name: e.group_name,
      branch: branches,
      contact_person: e.contact_person,
      contact_email: e.contact_email_id,
      contact_phone: e.contact_phone,
      country_code: e.country_code,
      annual_turnover: e.annul_turn_over,
      currency: e.currency,
      country: e.country,
      payments_terms: e.payment_terms,
      state: e.state,
      city: e.city,
      about: e.about,
    };
    console.log("Create Onboarding Data", data);
    SetSubmitData(data);
    handleClickOpen();

    // dispatch(raise_api_call_Create_partner(data));
  };

  // Set create and update date to the backend
  const handelSendData = () => {
    console.log("Send data", submitData);
    dispatch(raise_api_call_Create_partner(submitData));
  };
  // console.log(values.branch);
  // option

  const TypeOfBusinessOption =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "type_of_business") {
                return e;
              }
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];
  const partner_type_option =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "partner_type") {
                return e;
              }
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];

  const group_name_option =
    group_master_data.data.length != 0
      ? group_master_data.data.status
        ? group_master_data.data.result
            .filter((e: any) => {
              if (values.partner_type === "V" && "S" === e.group_type) {
                return e;
              }
              if (values.partner_type === e.group_type) {
                return e;
              }
            })
            .map((e: any) => {
              const data = { label: e.group_name, value: e.group_code };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];

  const currency_option =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "Currency") {
                return e;
              }
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];
  const country_option =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "country") {
                return e;
              }
            })
            .sort((a: any, b: any) => {
              return a.description > b.description ? 1 : -1;
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];

  const state_option =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "state") {
                if (e.key === stateKey) {
                  return e;
                }
              }
            })
            .sort((a: any, b: any) => {
              return a.description > b.description ? 1 : -1;
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];
  // const country_code_option: any = [
  //   { label: "No data", value: "vijay" },
  //   { label: "No 11", value: "123654789" },
  // ];
  // console.log(values);
  const country_codes = COUNTRIES.map((e: any) => {
    const data = { label: e.mobileCode, value: e.mobileCode };
    return data;
  });
  // Payment Terms Options
  const payment_terms =
    generalSettingList.data.length != 0
      ? generalSettingList.data.status
        ? generalSettingList.data.result
            .filter((e: any) => {
              if (e.page === "Payment Terms") {
                return e;
              }
            })
            .map((e: any) => {
              const data = { label: e.description, value: e.name };
              return data;
            })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];
  // console.log("payment_terms", payment_terms);

  useEffect(() => {
    setTitleContext("Onboarding");
    return () => {
      setTitleContext("");
    };
  }, []);

  return (
    <div className="list-onboarding">
      {responsePopup ? (
        <CompletePopup
          data={createApi}
          responsePopup={responsePopup}
          setCompletePopup={(e: any) => {
            setResponsePopup(false);
          }}
        />
      ) : (
        ""
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={
          group_master_data.isLoading ||
          generalSettingList.isLoading ||
          branch_master_data.isLoading ||
          createApi.isLoading
            ? true
            : false
        }
      >
        {/* <CircularProgress color="inherit" /> */}
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>

      <div className="onboarding_container">
        <div
          className="onboarding_header common_border_bottom"
          id="activesubnav"
        >
          <div className="mini_onboarding_header">
            <div className="sub-menu-icon"></div>
            <h5 className="f4 primary_text">Partner Onboarding</h5>
          </div>
        </div>

        <div className="mini_onboarding_container">
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className="field_item">
                <label className="f4">
                  Branch <span>*</span>
                </label>

                <FormControl
                  error={touched.branch && errors.branch ? true : false}
                >
                  <FormGroup
                    onChange={(e: any) => {
                      const index = values.branch.findIndex((object: any) => {
                        return object.name === e.target.name;
                      });

                      if (index >= 0) {
                        let items: any = [...values.branch];
                        const data: any = {
                          name: e.target.name,
                          value: e.target.checked,
                          id: Number(e.target.id),
                        };
                        items[index] = data;

                        setFieldValue("branch", items);
                      } else {
                        const result: any = [...values.branch];
                        result.push({
                          name: e.target.name,
                          value: e.target.checked,
                          id: e.target.id,
                        });
                        setFieldValue("branch", result);
                      }
                      setFieldTouched("branch", true, false);
                    }}
                    row
                  >
                    <div className="branch_container">
                      {branch_master_data.data.length != 0
                        ? branch_master_data.data.result.map(
                            (a: any, index: number) => {
                              return (
                                <div key={index} className="branch_item">
                                  <FormControlLabel
                                    label={
                                      <img
                                        src={configs.api + "/" + a.branch_logo}
                                        alt="branch name"
                                      ></img>
                                    }
                                    id={"12"}
                                    onChange={(e: any) => {
                                      // const data = [...arrayBranch];
                                      // data[0] = e.target.name;
                                      // setArrayBranch(data);
                                    }}
                                    name={a.branch_name}
                                    control={
                                      <Checkbox
                                        id={JSON.stringify(a.id)}
                                        checked={
                                          values.branch.filter((e: any) => {
                                            return (
                                              e.name === a.branch_name &&
                                              e.value
                                            );
                                          }).length != 0
                                            ? true
                                            : false
                                        }
                                      />
                                    }
                                  />
                                </div>
                              );
                            }
                          )
                        : ""}
                    </div>
                  </FormGroup>
                  {touched.branch && errors.branch ? (
                    <FormHelperText>branch is required</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextFiealdInput
                values={values}
                handleChange={handleChange}
                name="company_name"
                errors={errors}
                handleBlur={handleBlur}
                touched={touched}
                label="Company Name"
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextFiealdInput
                name="alter_name"
                label="Alternate Name"
                values={values}
                handleChange={handleChange}
                errors={errors}
                handleBlur={handleBlur}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={TypeOfBusinessOption}
                errors={errors}
                touched={touched}
                name="type_of_business"
                handleBlur={handleBlur}
                values={values}
                label="Type Of Business"
                vari={(e: any) => {
                  setFieldValue("type_of_business", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={partner_type_option}
                name="partner_type"
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
                label="Partner Type"
                vari={(e: any) => {
                  setFieldValue("partner_type", e ? e.value : "");
                  setFieldValue("group_name", "");
                }}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={group_name_option}
                name="group_name"
                label="Group Name"
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
                vari={(e: any) => {
                  setFieldValue("group_name", e ? e.value : "");
                  if (values.partner_type != "C") {
                    dispatch(
                      test_agreement_available_from_api({
                        partner_type: values.partner_type,
                        group_name: e.value,
                      })
                    );
                  }
                }}
              />
            </Grid>
            {values.partner_type == "V" && values.group_name == "162" ? (
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <TextFiealdInput
                  notRequire={true}
                  name="employee_id"
                  label="Employee ID"
                  touched={touched}
                  errors={errors}
                  values={values}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                />
              </Grid>
            ) : (
              ""
            )}

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
                name="contact_person"
                label="Contact Person"
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="contact_email_id"
                label="Contact Email id"
                handleChange={(e: any) => {
                  setFieldValue(
                    "contact_email_id",
                    e.target.value.toLowerCase()
                  );
                }}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="field_item">
                <label className="f4">
                  Contact Phone No <span>*</span>
                </label>

                <TextField
                  placeholder="Contact Phone No"
                  className="custom_textfield"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.contact_phone}
                  error={
                    touched.contact_phone && errors.contact_phone ? true : false
                  }
                  helperText={
                    touched.contact_phone && errors.contact_phone
                      ? errors.contact_phone
                      : ""
                  }
                  name="contact_phone"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Select
                          value={values.country_code}
                          onChange={(e) => {
                            setFieldValue("country_code", `${e.target.value}`);
                          }}
                          name="country_code"
                          // displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={{
                            width: "75px",
                            marginRight: "-10px",
                          }}
                        >
                          {COUNTRIES.map((e: any) => {
                            return (
                              <MenuItem value={e.mobileCode}>
                                {e.mobileCode}
                              </MenuItem>
                            );
                          })}
                          country_codes
                        </Select>
                        {/* <Autocomplete
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": {
                              // top: 0,
                              border: "2px solid #c4c4c4",
                              borderRadius: "0px",
                            },
                            // borderRadius: "0px",
                            fontWeight: "700",
                            fontFamily: "Roboto",
                            // height: "50px",
                            borderRadius: "0px",
                          }}
                          // value={values.business_type}
                          options={country_codes}
                          onChange={(e, value: any) => {
                            const a = value ? value.value : "";
                            // vari(a);

                            setFieldValue("business_type", a);
                          }}
                          renderInput={(params) => (
                            <TextField
                              sx={{
                                textTransform: "capitalize",
                              }}
                              onBlur={handleBlur}
                              // error={
                              //   touched.business_type && errors.business_type
                              //     ? true
                              //     : false
                              // }
                              // helperText={
                              //   touched.business_type && errors.business_type
                              //     ? errors.business_type
                              //     : ""
                              // }
                              name="business_type"
                              placeholder="Select Type"
                              {...params}
                            />
                          )}
                        /> */}
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: "0px",
                      height: "50px",
                      padding: "0px",
                    },
                  }}
                />
              </div>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="annul_turn_over"
                label="Annual Turn Over"
                alignend={true}
                handleChange={handleChange}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={currency_option}
                errors={errors}
                touched={touched}
                name="currency"
                handleBlur={handleBlur}
                values={values}
                label="Currency"
                vari={(e: any) => {
                  setFieldValue("currency", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={country_option}
                errors={errors}
                touched={touched}
                name="country"
                handleBlur={handleBlur}
                values={values}
                label="Country"
                vari={(e: any) => {
                  generalSettingList.data.result.map((a: any) => {
                    if (a.name === (e ? e.value : "")) {
                      setStateKey(a.key);
                    }
                  });
                  setFieldValue("country", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={state_option}
                errors={errors}
                touched={touched}
                name="state"
                handleBlur={handleBlur}
                values={values}
                label="State"
                vari={(e: any) => {
                  setFieldValue("state", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFiealdInput
                name="city"
                label="City"
                touched={touched}
                errors={errors}
                values={values}
                handleChange={(e: any) => {
                  if (e.target.value) {
                    setFieldValue(
                      "city",
                      e.target.value[0].toUpperCase() +
                        e.target.value.slice(1).toLowerCase()
                    );
                  } else {
                    setFieldValue("city", e.target.value);
                  }
                }}
                handleBlur={handleBlur}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <AutoComplete
                pageOption={payment_terms}
                name="payment_terms"
                touched={touched}
                setpayment_term_code={setpayment_term_code}
                errors={errors}
                values={values}
                handleBlur={handleBlur}
                label="Payment Terms"
                vari={(e: any) => {
                  // console.log(e);
                  // props.setpayment_term_code(e ? e.key : "");
                  setpayment_term_code(e ? e.key : "");
                  setFieldValue("payment_terms", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className="field_item" id="abouts">
                <label className="">
                  About <span>*</span>
                </label>
                <TextField
                  className="custom_textfield"
                  value={values.about}
                  onChange={handleChange}
                  name="about"
                  error={touched.about && errors.about ? true : false}
                  helperText={touched.about && errors.about ? errors.about : ""}
                  placeholder="About"
                  onBlur={handleBlur}
                  multiline
                  id="about"
                  rows={4}
                />
              </div>
            </Grid>
          </Grid>

          <div className="onboarding_footer">
            <Button
              className="common_btn_outline"
              disableRipple
              onClick={() => {
                navigate("/business-partner/partner-details");
              }}
            >
              Cancel
            </Button>
            <Button
              className="common_btn"
              disableRipple
              onClick={() => handleSubmit()}
            >
              {createApi.isLoading ? "Please Wait ..." : "Send For Approval"}
            </Button>
          </div>
        </div>
      </div>

      <Dialog
        PaperProps={{
          style: { width: "500px" },
        }}
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="dialog_header common_border_bottom">
          <h4 id="alert-dialog-title" className="f4">
            {"Confirmation"}{" "}
          </h4>

          <CancelIcon
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <DialogContent>
          Are you sure want to send the onboarding partner approval?
          {/* <DialogContentText id="alert-dialog-description"> */}
          {/* </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <div className="dialog_footer">
            <Button
              disableRipple
              onClick={handleClose}
              className="common_btn_outline"
            >
              Cancel
            </Button>
            <Button
              disableRipple
              className="common_btn"
              onClick={() => {
                // handleSubmit();
                handelSendData();
                handleClose();
              }}
            >
              Send
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default OnBoarding;
